module.exports = __webpack_public_path__ + "img/framenew_box28.7f9097d3.jpg";